
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/purpose",
      function () {
        return require("private-next-pages/purpose.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/purpose"])
      });
    }
  